import { AppBar } from '@mui/material'
import { styled } from '@mui/material/styles'

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  '& .MuiToolbar-root': { paddingLeft: 0 }
}))

function CustomAppBar({ children }: Readonly<{ children: React.ReactNode }>) {
  return (
    <StyledAppBar position="sticky" color="transparent" elevation={1}>
      {children}
    </StyledAppBar>
  )
}
export default CustomAppBar
